// extracted by mini-css-extract-plugin
export default {"paginationCounter":"PaginationCounter_paginationCounter__36DXq"};